export default class ConstantsPushApps {
  public static readonly templateTypes = [
    {text: 'Articulo', value: 'article'},
    {text: 'Opinion', value: 'opinion'},
    {text: 'Video', value: 'video'}
  ];
}
